import { createSelector } from 'reselect';
import { getUsers } from 'selectors/usersSelectors';
import { UserSelf } from 'shared/models';
import { State } from 'reducers';

export const getSessionState =
    (state: State) => state.session;

export const getCurrentUserId =
    createSelector(getSessionState,
        state => state.userId
    );

export const getCurrentUser =
    createSelector(
        getCurrentUserId,
        getUsers,
        (userId, users) => ((userId && users && users[userId]) || null) as UserSelf | null
    );

export const getCurrentUserPermissions =
    createSelector(
        getSessionState,
        state => state.permissions || {}
    );
